module.exports = __webpack_public_path__ + "static/media/virgen-coromoto.db5447ed.jpg";